export default __webpack_public_path__ + "static/media/img-0784-portugal-full-face.80992efa.png";